import { MappedClass, MappedProperty, MappedPropertyClass, MappedPropertyCurrency } from '@h5s/util-object';
import { CashRegisterItemType } from './cash-register-item-type.enum';
import { Department } from '../../settings/entities';
import { Big } from 'big.js';

@MappedClass()
export class CashRegisterItem {
  @MappedPropertyCurrency()
  amount: Big | null;

  @MappedPropertyClass(() => Department)
  department: Department | null;

  @MappedProperty()
  description: string | null;

  @MappedProperty()
  note: string | null;

  @MappedProperty()
  type: CashRegisterItemType;
}
